class CustomTabSwitching extends HTMLElement {
    constructor() {
        super();
        this.handleTabSwitching = this.handleTabSwitching.bind(this);
    }

    connectedCallback() {
        this.tabSwitchingButtons = this.querySelectorAll('.tab-img-box');
        this.collections = this.querySelectorAll('.collection-container');

        if(!this.tabSwitchingButtons.length || !this.collections.length){
            console.warn('Tab switching elements not found');
            throw new Error('Required tab switching elements not found. Please ensure both tabs and collections are present.');
        }

        this.tabSwitchingButtons.forEach(eachTabSwitch => {
            eachTabSwitch.setAttribute('role', 'tab');
            eachTabSwitch.setAttribute('aria-selected', 'false');
            eachTabSwitch.addEventListener('click', this.handleTabSwitching);
        });

        this.collections.forEach(collection =>{
            collection.setAttribute('role', 'tabpanel');
            collection.setAttribute('aria-hidden', 'true');
        });

        // Set initial tab as active
       if (this.tabSwitchingButtons[0]) {
        this.tabSwitchingButtons[0].setAttribute('aria-selected', 'true');
        this.collections[0]?.setAttribute('aria-hidden', 'false');
        };
    }

    handleTabSwitching(event) {
        // Remove active class from all tabs
        this.tabSwitchingButtons.forEach(eachTabSwitch => {
            eachTabSwitch.classList.remove('is-tab-active');
            eachTabSwitch.setAttribute('aria-selected', 'false');
            eachTabSwitch.setAttribute('tabindex', '-1');
        });

        // Remove active class from all collections
        this.collections.forEach(eachCollection => {
            eachCollection.classList.remove('is--active');
            eachCollection.setAttribute('aria-hidden', 'true');
        });

        // Add active class to clicked tab
        event.currentTarget.classList.add('is-tab-active');
        event.currentTarget.setAttribute('aria-selected', 'true');
        event.currentTarget.setAttribute('tabindex', '0');

        // Find the related collection and activate it
        const collectionName = event.currentTarget.dataset.tab;
        const activeCollection = this.querySelector(`.collection-container.${collectionName}`);

        if (!activeCollection) {
            console.error(`Collection not found for tab: ${collectionName}`);
            return;
        }
        
        if (activeCollection) {
            activeCollection.classList.add('is--active');
            activeCollection.setAttribute('aria-hidden', 'false');
        }
    }

    disconnectedCallback() {
        this.tabSwitchingButtons.forEach(eachTabSwitch => {
            eachTabSwitch.removeEventListener('click', this.handleTabSwitching);
        });
    }
}

customElements.define('custom-tab-switching', CustomTabSwitching);
